export const environment = {
  production: true,
  localStorageEncryptionKey: 'hyYGV8GVv8298NUG93',
  cookiesEncryptionKey: 'Ibn89B767d5CVpo087',
  bffApi: 'http://mno-touchpoint-bff.auto.svc.cluster.local:3002'                                     
};
